import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getObjects = createAsyncThunk('objects/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/objects/all/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const getObject = createAsyncThunk('object/get', async (objectId, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get(`/api/objects/${objectId}/`)
    return data
  } catch (error) {
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const saveObject = createAsyncThunk('object/save', async (obj, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.put(`/api/objects/${obj.id}/`, obj)
    return data
  } catch (error) {
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const createObject = createAsyncThunk('object/create', async (obj, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.post('/api/objects/', obj)
    return data
  } catch (error) {
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const deleteObject = createAsyncThunk('object/delete', async (obj, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.delete(`/api/objects/${obj.id}/`)
    return data
  } catch (error) {
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})
